import { render, staticRenderFns } from "./ListViewStudentIdAndUnivemailInput.vue?vue&type=template&id=69f5ad84&"
import script from "./ListViewStudentIdAndUnivemailInput.vue?vue&type=script&lang=js&"
export * from "./ListViewStudentIdAndUnivemailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports